import mutationTypes from '../mutation-types.js'

const state = {
  defaultPageSize: 32767,
  maxAccessoryEvents: 5,
  maxLoanerEvents: 5,
  maxServiceRequests: 5,
  maxSupplierContacts: 5,
  types: {
    paymentMethods: [
      {
        id: 0,
        name: 'Check'
      },
      {
        id: 1,
        name: 'Wire'
      }
    ],
    bankAccountTypes: [
      {
        id: 0,
        name: 'Check'
      },
      {
        id: 1,
        name: 'Savings'
      }
    ],
    customerMaritalStatus: {
      Unmarried: 0,
      Married: 1,
      Separated: 2,
      options:
      [
        {
          id: 0,
          name: 'Unmarried'
        },
        {
          id: 1,
          name: 'Married'
        },
        {
          id: 2,
          name: 'Separated'
        }
      ]
    },
    fillTypes: {
      Yes: 0,
      No: 1,
      options:
      [
        {
          id: 0,
          name: 'Yes',
          ico: 'fas fa-check has-text-success'
        },
        {
          id: 1,
          name: 'No',
          ico: 'fas fa-times has-text-danger'
        }
      ]
    },
    ownershipTypes: {
      Own: 0,
      Rent: 1,
      options:
      [
        {
          id: 0,
          name: 'Own'
        },
        {
          id: 1,
          name: 'Rent'
        }
      ]
    },
    employmentStatus: {
      Employed: 0,
      Unemployed: 1,
      Retired: 2,
      ActiveMilitary: 3,
      RetiredMilitary: 4,
      options:
      [
        {
          id: 0,
          name: 'Employed',
          altName: 'Employed'
        },
        {
          id: 1,
          name: 'Unemployed',
          altName: 'Unemployed'
        },
        {
          id: 2,
          name: 'Retired',
          altName: 'Retired'
        },
        {
          id: 3,
          name: 'ActiveMilitary',
          altName: 'Active Military'
        },
        {
          id: 4,
          name: 'RetiredMilitary',
          altName: 'Retired Military'
        }
      ]
    },
    incomeSourceType: {
      SalaryWages: 0,
      IncomeBonusIncome: 1,
      Retirement: 2,
      ChildSupport: 3,
      FamilySpousalSupport: 4,
      Disability: 5,
      HousingAllowance: 6,
      MilitaryAllowance: 7,
      MunicipalBondInterest: 8,
      PublicAssitancePrograms: 9,
      SocialSecurityBenefits: 10,
      WorkersCompensation: 11,
      OtherTaxable: 12,
      OtherNonTaxable: 13,
      options:
        [
          {
            id: 0,
            name: 'SalaryWages',
            altName: 'Salary/Wages'
          },
          {
            id: 1,
            name: 'IncomeBonusIncome',
            altName: 'Incentive or Bonus Income'
          },
          {
            id: 2,
            name: 'Retirement',
            altName: 'Retirement'
          },
          {
            id: 3,
            name: 'ChildSupport',
            altName: 'Child Support'
          },
          {
            id: 4,
            name: 'FamilySpousalSupport',
            altName: 'Family or Spousal Support/Alimony'
          },
          {
            id: 5,
            name: 'Disability',
            altName: 'Disablity'
          },
          {
            id: 6,
            name: 'HousingAllowance',
            altName: 'Housing Allowance'
          },
          {
            id: 7,
            name: 'MilitaryAllowance',
            altName: 'Military Allowance'
          },
          {
            id: 8,
            name: 'MunicipalBondInterest',
            altName: 'Municipal Bond Interest'
          },
          {
            id: 9,
            name: 'PublicAssitancePrograms',
            altName: 'Public Assistance Programs'
          },
          {
            id: 10,
            name: 'SocialSecurityBenefits',
            altName: 'Social Security Benefits'
          },
          {
            id: 11,
            name: 'WorkersCompensation',
            altName: 'Workers\' Compensation'
          },
          {
            id: 12,
            name: 'OtherTaxable',
            altName: 'Other (taxable)'
          },
          {
            id: 13,
            name: 'OtherNonTaxable',
            altName: 'Other (non-taxable)'
          }
        ]
    },
    usStateLookup: {
      Alabama: 0,
      Alaska: 1,
      Arizona: 2,
      Arkansas: 3,
      California: 4,
      Colorado: 5,
      Connecticut: 6,
      Delaware: 7,
      DistrictOfColumbia: 8,
      Florida: 9,
      Georgia: 10,
      Hawaii: 11,
      Idaho: 12,
      Illinois: 13,
      Indiana: 14,
      Iowa: 15,
      Kansas: 16,
      Kentucky: 17,
      Louisiana: 18,
      Maine: 19,
      Maryland: 20,
      Massachusetts: 21,
      Michigan: 22,
      Minnesota: 23,
      Mississippi: 24,
      Missouri: 25,
      Montana: 26,
      Nebraska: 27,
      Nevada: 28,
      NewHampshire: 29,
      NewJersey: 30,
      NewMexico: 31,
      NewYork: 32,
      NorthCarolina: 33,
      NorthDakota: 34,
      Ohio: 35,
      Oklahoma: 36,
      Oregon: 37,
      Pennsylvania: 38,
      RhodeIsland: 39,
      SouthCarolina: 40,
      SouthDakota: 41,
      Tennessee: 42,
      Texas: 43,
      Utah: 44,
      Vermont: 45,
      Virginia: 46,
      Washington: 47,
      WestVirginia: 48,
      Wisconsin: 49,
      Wyoming: 50,
      options:
        [
          {
            id: 0,
            name: 'Alabama',
            abbreviation: 'AL',
            communityProperty: false,
            requiresBackOfDriversLicense: true,
            requiresExactDriversLicenseSize: true
          },
          {
            id: 1,
            name: 'Alaska',
            abbreviation: 'AK',
            communityProperty: false,
            requiresBackOfDriversLicense: true,
            requiresExactDriversLicenseSize: true
          },
          {
            id: 2,
            name: 'Arizona',
            abbreviation: 'AZ',
            communityProperty: true,
            requiresBackOfDriversLicense: true,
            requiresExactDriversLicenseSize: true
          },
          {
            id: 3,
            name: 'Arkansas',
            abbreviation: 'AR',
            communityProperty: false,
            requiresBackOfDriversLicense: true,
            requiresExactDriversLicenseSize: true
          },
          {
            id: 4,
            name: 'California',
            abbreviation: 'CA',
            communityProperty: true,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 5,
            name: 'Colorado',
            abbreviation: 'CO',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 6,
            name: 'Connecticut',
            abbreviation: 'CT',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 7,
            name: 'Delaware',
            abbreviation: 'DE',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 8,
            name: 'District Of Columbia',
            abbreviation: 'DC',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 9,
            name: 'Florida',
            abbreviation: 'FL',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 10,
            name: 'Georgia',
            abbreviation: 'GA',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 11,
            name: 'Hawaii',
            abbreviation: 'HI',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 12,
            name: 'Idaho',
            abbreviation: 'ID',
            communityProperty: true,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 13,
            name: 'Illinois',
            abbreviation: 'IL',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 14,
            name: 'Indiana',
            abbreviation: 'IN',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 15,
            name: 'Iowa',
            abbreviation: 'IA',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 16,
            name: 'Kansas',
            abbreviation: 'KS',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 17,
            name: 'Kentucky',
            abbreviation: 'KY',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 18,
            name: 'Louisiana',
            abbreviation: 'LA',
            communityProperty: true,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 19,
            name: 'Maine',
            abbreviation: 'ME',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 20,
            name: 'Maryland',
            abbreviation: 'MD',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 21,
            name: 'Massachusetts',
            abbreviation: 'MA',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 22,
            name: 'Michigan',
            abbreviation: 'MI',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 23,
            name: 'Minnesota',
            abbreviation: 'MN',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 24,
            name: 'Mississippi',
            abbreviation: 'MS',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 25,
            name: 'Missouri',
            abbreviation: 'MO',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 26,
            name: 'Montana',
            abbreviation: 'MT',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 27,
            name: 'Nebraska',
            abbreviation: 'NE',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 28,
            name: 'Nevada',
            abbreviation: 'NV',
            communityProperty: true,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 29,
            name: 'New Hampshire',
            abbreviation: 'NH',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 30,
            name: 'New Jersey',
            abbreviation: 'NJ',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 31,
            name: 'New Mexico',
            abbreviation: 'NM',
            communityProperty: true,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 32,
            name: 'New York',
            abbreviation: 'NY',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 33,
            name: 'North Carolina',
            abbreviation: 'NC',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 34,
            name: 'North Dakota',
            abbreviation: 'ND',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 35,
            name: 'Ohio',
            abbreviation: 'OH',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 36,
            name: 'Oklahoma',
            abbreviation: 'OK',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 37,
            name: 'Oregon',
            abbreviation: 'OR',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 38,
            name: 'Pennsylvania',
            abbreviation: 'PA',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 39,
            name: 'Rhode Island',
            abbreviation: 'RI',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 40,
            name: 'South Carolina',
            abbreviation: 'SC',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 41,
            name: 'South Dakota',
            abbreviation: 'SD',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 42,
            name: 'Tennessee',
            abbreviation: 'TN',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 43,
            name: 'Texas',
            abbreviation: 'TX',
            communityProperty: true,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 44,
            name: 'Utah',
            abbreviation: 'UT',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 45,
            name: 'Vermont',
            abbreviation: 'VT',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 46,
            name: 'Virginia',
            abbreviation: 'VA',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 47,
            name: 'Washington',
            abbreviation: 'WA',
            communityProperty: true,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 48,
            name: 'West Virginia',
            abbreviation: 'WV',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 49,
            name: 'Wisconsin',
            abbreviation: 'WI',
            communityProperty: true,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          },
          {
            id: 50,
            name: 'Wyoming',
            abbreviation: 'WY',
            communityProperty: false,
            requiresBackOfDriversLicense: false,
            requiresExactDriversLicenseSize: false
          }
        ]
    },
    relationshipStatus: {
      Spouse: 0,
      Relative: 1,
      RegDomPr: 2,
      CivilUnion: 3,
      Other: 4,
      None: 5,
      options:
      [
        {
          id: 0,
          name: 'Spouse',
          altName: 'Spouse'
        },
        {
          id: 1,
          name: 'Relative',
          altName: 'Relative'
        },
        {
          id: 2,
          name: 'RegDomPr',
          altName: 'Registered Domestic Partner'
        },
        {
          id: 3,
          name: 'CivilUnion',
          altName: 'Civil Union'
        },
        {
          id: 4,
          name: 'Other',
          altName: 'Other'
        },
        {
          id: 5,
          name: 'None',
          altName: 'None'
        }
      ]
    },
    financialStatementType: {
      CpaAudited: 0,
      CpaReviewed: 1,
      CpaCompiled: 2,
      IncomeTax: 3,
      BorrowerPrepared: 4,
      None: 5,
      options:
      [
        {
          id: 0,
          name: 'CpaAudited',
          altName: 'Cpa Audited'
        },
        {
          id: 1,
          name: 'CpaReviewed',
          altName: 'Cpa Reviewed'
        },
        {
          id: 2,
          name: 'CpaCompiled',
          altName: 'Cpa Compiled'
        },
        {
          id: 3,
          name: 'IncomeTax',
          altName: 'Income Tax'
        },
        {
          id: 4,
          name: 'BorrowerPrepared',
          altName: 'Borrower Prepared'
        },
        {
          id: 5,
          name: 'None',
          altName: 'None'
        }
      ]
    },
    businessType: {
      Corporation: 0,
      LLC: 1,
      Partnership: 2,
      Proprietor: 3,
      Other: 4,
      options:
      [
        {
          id: 0,
          name: 'Corporation',
          altName: 'Corporation'
        },
        {
          id: 1,
          name: 'LLC',
          altName: 'LLC'
        },
        {
          id: 2,
          name: 'Partnership',
          altName: 'Partnership'
        },
        {
          id: 3,
          name: 'Proprietor',
          altName: 'Proprietor'
        },
        {
          id: 4,
          name: 'Other',
          altName: 'Other'
        }
      ]
    },
    financeMethodType: {
      Finance: 0,
      Lease: 1,
      Balloon: 2,
      options:
      [
        {
          id: 0,
          name: 'Finance',
          altName: 'Finance'
        },
        {
          id: 1,
          name: 'Lease',
          altName: 'Lease'
        },
        {
          id: 2,
          name: 'Balloon',
          altName: 'Balloon'
        }
      ]
    },
    valetDeliveryType: {
      InPersonCollection: 0,
      Delivery: 1,
      options:
      [
        {
          id: 0,
          name: 'In Person Collection',
          altName: 'InPersonCollection'
        },
        {
          id: 1,
          name: 'Delivery',
          altName: 'Delivery'
        }
      ]
    },
    valetWashingNotificationType: {
      VehicleWashing: 0,
      Valet: 1,
      VehicleWashingThenValet: 2,
      options:
      [
        {
          id: 0,
          name: 'Vehicle Washing',
          altName: 'VehicleWashing'
        },
        {
          id: 1,
          name: 'Valet',
          altName: 'Valet'
        },
        {
          id: 2,
          name: 'Vehicle Washing Then Valet',
          altName: 'VehicleWashingThenValet'
        }
      ]
    },
    valetWashingStatus: {
      Pending: 0,
      InProgress: 1,
      Completed: 2,
      options:
      [
        {
          id: 0,
          name: 'Pending',
          altName: 'Pending'
        },
        {
          id: 1,
          name: 'In Progress',
          altName: 'InProgress'
        },
        {
          id: 2,
          name: 'Completed',
          altName: 'Completed'
        }
      ]
    }
  }
}

const getters = {
  defaultListPageSize: state => {
    return state.defaultPageSize
  },
  definedTypes: state => {
    return state.types
  }
}

const mutations = {
  [mutationTypes.SET_DEFAULT_PAGE_SIZE] (state, pageSize) {
    state.defaultPageSize = pageSize
  }
}

const actions = {
  setDefaultPageSize ({ commit, state }, pageSize) {
    commit(mutationTypes.SET_DEFAULT_PAGE_SIZE, pageSize)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
